import { Component, Inject, Vue } from 'vue-property-decorator';
import { VERSION } from '@/constants';
import LoginService from '@/account/login.service';

import { IAdvertisement } from '@/shared/model/advertisement.model';
import { ICompanyRatingsDTO } from '@/shared/model/dto/company-ratings-dto';

import AccountService from '@/account/account.service';
import TranslationService from '@/locale/translation.service';
import AdvertisementService from '@/entities/advertisement/advertisement.service';
import CollaborationService from '../../entities/collaboration/collaboration.service';

import SearchPageService from '../../core/b2b-jhi-navbar/searchpage.service';

import { mixins } from 'vue-class-component';

import Vue2Filters from 'vue2-filters';
import AlertMixin from '@/shared/alert/alert.mixin';
/* Error in production
@Component({
  mixins: [Vue2Filters.mixin],
})
*/
const advProps = Vue.extend({
  props: {
    advertisements: null,
    cmsnews: null,
    cmsquestions: null,
    companies: null,
  },
});

@Component
export default class SearchSection extends advProps {
  @Inject('translationService') private translationService: () => TranslationService;
  @Inject('advertisementService') private advertisementService: () => AdvertisementService;
  @Inject('collaborationService') private collaborationService: () => CollaborationService;

  private currentLanguage = this.$store.getters.currentLanguage;
  private languages: any = this.$store.getters.languages;
  private mainSearchCategory = 1;
  public companyRatingsDTOs: ICompanyRatingsDTO[] = [];
  public advertisements; // Error in production
  // public advertisements = []

  data() {
    return {
      toggle: true,
      dissbutton: 'disabled',
    };
  }

  created() {
    this.translationService().refreshTranslation(this.currentLanguage);
    this.mainSearchCategory = 1;

    // const message = this.$t('riportalApp.researchInfrastructure.errors.deleteFailed');
    this.currentLanguage = this.$store.getters.currentLanguage;
    this.$store.watch(
      () => this.$store.getters.currentLanguage,
      () => {
        this.currentLanguage = this.$store.getters.currentLanguage;
      }
    );

    this.$store.watch(
      () => this.advertisements,
      () => {
        this.getRatingsForCompanies();
      }
    );

    //alert(this.$t('riportalApp.researchInfrastructure.errors.deleteFailed') + this.currentLanguage);
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }

  public advertisementCategorizationBranch(advertisement: IAdvertisement): string {
    const currentLanguage = this.$store.getters.currentLanguage;
    return this.advertisementService().advertisementCategorizationBranch(advertisement, currentLanguage);
  }

  public advertisementKindsString(advertisement: IAdvertisement): string {
    const currentLanguage = this.$store.getters.currentLanguage;
    return this.advertisementService().advertisementKindsString(advertisement, currentLanguage);
  }

  emitHideAllEvent(): void {
    this.$emit('hide-all');
  }

  public getRatingsForCompanies(): void {
    if (!this.advertisements) {
      return
    }

    this.advertisements.forEach(async (advertisement: IAdvertisement) => {
      if (!advertisement.company) {
        return;
      }

      let companyRatingsDTO = this.companyRatingsDTOs.find(companyRatingsDTO => companyRatingsDTO.companyId === advertisement.company.id)

      if (companyRatingsDTO) {
        return;
      }

      await this.collaborationService()
      .getCompanyRatings(advertisement.company.id)
      .then(res => {
        this.companyRatingsDTOs.push(res);
      });
   });
  }

  public getAverageRatingForCompany(companyId: number): number | null {
    let companyRatingsDTO = this.companyRatingsDTOs.find(companyRatingsDTO => companyRatingsDTO.companyId === companyId);

    if (!companyRatingsDTO) {
      return null;
    }

    return companyRatingsDTO.averageRating;
  }

  public getTotalRatingsForCompany(companyId: number): number | null {
    let companyRatingsDTO = this.companyRatingsDTOs.find(company => company.companyId === companyId);

    if (!companyRatingsDTO) {
      return null;
    }

    return companyRatingsDTO.totalRatings;
  }
}
